/******************************************************************/
/*****Initially Created By Fahad Akbar(fahadakbar24@gmail.com)*****/
/******************************************************************/

import {
  isSelected
} from './../utils/common';

angular
  .module('app.services')
  .factory('locationsService', ['$http', function($http) {

  	let instance = {
      isSelected: (location) => isSelected(location),
      createHeirarchy: (linearLocations) => {
        let heirarchicalLocations = [];

        linearLocations.forEach((loc, index, array) => {
          if (loc.region === null && loc.area === null) {
            loc.locations = [];
            heirarchicalLocations.push(loc);
            linearLocations.forEach((region_area, index, array) => {
              if (region_area.region === loc.loc_ID && region_area.area === null) {
                region_area.sub_areas = [];
                loc.locations.push(region_area);
                linearLocations.forEach((sub_area, index, array) => {
                  if (sub_area.region !== null && sub_area.area === region_area.loc_ID) {
                    region_area.sub_areas.push(sub_area);
                  }
                });
              }
            });
          }
        });

        return heirarchicalLocations;
      },
      linearize: (heirarchicalLocations) => {
        let linearLocations = [];

        heirarchicalLocations.forEach( (region, index, array) => {
          if (instance.isSelected(region)){ linearLocations.push(region); }

          region.locations.forEach( (location, index, array) => {
            if (instance.isSelected(location)){ linearLocations.push(location); }

            location.sub_areas.forEach( (subArea, index, array) => {
              if (instance.isSelected(subArea)){ linearLocations.push(subArea); }
            });
          });
        });

        return linearLocations;
      },
      clearSelection: (heirarchicalLocations, selection = false) => {
        heirarchicalLocations.forEach( region => {
          region.isSelected = selection;

          region.locations.forEach( location => {
            location.isSelected = selection;

            location.sub_areas.forEach( sub => {
              sub.isSelected = selection;

            });
          });
        });

      },
      map: (linearLocations, heirarchicalLocations) => {
        instance.clearSelection(heirarchicalLocations);

        linearLocations.forEach( (tLoc, index, array) => {
          heirarchicalLocations.forEach((loc)=>{

            loc.locations.forEach((region_area)=>{
              if(tLoc.loc_ID === region_area.loc_ID){
                loc.isSelected = true;
                region_area.isSelected = true;
              }
              region_area.sub_areas.forEach((sub_area)=>{
                if(tLoc.loc_ID === sub_area.loc_ID){
                  loc.isSelected = true;
                  region_area.isSelected = true;
                  sub_area.isSelected = true;
                }
              });
            });
          });
        });

      },
      select: (heirarchicalLocations, event, current, level, count)=> {

        let pCounter, sCounter, value;
        pCounter = 0;
        sCounter = 0;
        value = event.target.checked;
        if (level === 2) {
          heirarchicalLocations.forEach(function(region, index, array) {
            if (region.loc_ID === current.loc_ID) {
              region.isSelected = value;
              if (region.locations.length > 0) {
                region.locations.forEach(function(location, index, array) {
                  location.isSelected = value;
                  location.sub_areas.forEach(function(sub, index, array) {
                    if (sub.isSelected !== value) {
                      if (value) {
                        sub.isSelected = value;
                        count++;
                      } else if (!value) {
                        sub.isSelected = value;
                        count--;
                      }
                    }
                  });
                  if (value) {
                    location.isSelected = value;
                    count++;
                  } else if (!value && location.isSelected) {
                    location.isSelected = value;
                    count--;
                  }
                });
              } else {
                if (value) {
                  region.isSelected = value;
                  count++;
                } else if (!value) {
                  region.isSelected = value;
                  count--;
                }
              }
            }
          });
        } else if (level === 1) {
          heirarchicalLocations.forEach(function(region, index, array) {
            region.locations.forEach(function(location, index, array) {
              if (location.loc_ID === current.loc_ID) {
                if (location.sub_areas.length > 0) {
                  location.isSelected = value;
                  region.locations.forEach(function(p, i, a) {
                    if (p.isSelected) {
                      pCounter++;
                    }
                  });
                  if (value) {
                    if (pCounter > 0) {
                      region.isSelected = value;
                    }
                  } else {
                    if (pCounter <= 0) {
                      region.isSelected = value;
                    }
                  }
                  location.sub_areas.forEach(function(sub, index, array) {
                    if (sub.isSelected !== value) {
                      if (value) {
                        sub.isSelected = value;
                        count++;
                      } else if (!value) {
                        if (sub.isSelected) {
                          sub.isSelected = value;
                          count--;
                        }
                      }
                    }
                  });
                } else {
                  if (value) {
                    location.isSelected = value;
                    region.locations.forEach(function(p, i, a) {
                      if (p.isSelected) {
                        pCounter++;
                      }
                    });
                    if (value) {
                      if (pCounter > 0) {
                        region.isSelected = value;
                      }
                    } else {
                      if (pCounter <= 0) {
                        region.isSelected = value;
                      }
                    }
                    count++;
                  } else if (!value) {
                    location.isSelected = value;
                    region.locations.forEach(function(p, i, a) {
                      if (p.isSelected) {
                        pCounter++;
                      }
                    });
                    if (value) {
                      if (pCounter > 0) {
                        region.isSelected = value;
                      }
                    } else {
                      if (pCounter <= 0) {
                        region.isSelected = value;
                      }
                    }
                    count--;
                  }
                }
              }
            });
          });
        } else if (level === 0) {
          heirarchicalLocations.forEach(function(region, index, array) {
            region.locations.forEach(function(location, index, array) {
              if (location.sub_areas.length > 0) {
                location.sub_areas.forEach(function(sub, index, array) {
                  if (sub.loc_ID === current.loc_ID) {
                    sub.isSelected = value;
                    location.sub_areas.forEach(function(s, i, a) {
                      if (s.isSelected) {
                        sCounter++;
                      }
                    });
                    if (value) {
                      if (sCounter > 0) {
                        region.isSelected = value;
                        location.isSelected = value;
                      }
                    } else {
                      if (sCounter <= 0) {
                        location.isSelected = value;
                        region.locations.forEach(function(p, i, a) {
                          if (p.isSelected) {
                            pCounter++;
                          }
                        });
                        if (value) {
                          if (pCounter > 0) {
                            region.isSelected = value;
                          }
                        } else {
                          if (pCounter <= 0) {
                            region.isSelected = value;
                          }
                        }
                      }
                    }
                    if (value) {
                      count++;
                    } else {
                      count--;
                    }
                  }
                });
              }
            });
          });
        }
      }
  	};

  	return instance;
  }]);



// WEBPACK FOOTER //
// ./scripts/shared/services/locations.js